import React, { useEffect, useState } from "react";
import LessonList from "../component/lessonsList/lessonsList";
import * as lmsAction from "../../../redux/actions/lmsAction";
import { useDispatch, useSelector } from "react-redux";
import LmsHeader from "../component/lmsHeader/lmsHeader";
import {
  CREATE_LESSON,
  COURSES,
  LESSON,
  ACCESS_DENIED,
  COURSES_SCORM,
  LESSONDETAIL,
  USER_ASSIGNED_LESSON,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import {
  PAGE_SIZE,
  ORG_ID,
  USER_ID,
  API_STATUS,
} from "../../../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../../library/common/Loader";
import * as quizAction from "../../../redux/actions/quizAction";
import { getPreviousRoute } from "../../../utils/routeTracker";

const LessonsContainer = () => {
  const dispatch = useDispatch();
  const LessondeleteStatus = useSelector((state) => state.deleteLesson.status);
  const [isdisable, setisdisable] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const publishLessonStatus = useSelector(
    (state) => state.publishLesson.status,
  );
  const location = useLocation();
  let navigate = useNavigate();
  const [iscloneBtnClick, setIscloneBtnClick] = useState(false);
  const [openGrandAccess, setOpenGrandAccess] = useState(false);
  const [defaultLessonTab] = useState(() =>
    location?.state?.defaultLessonTab !== undefined
      ? location.state.defaultLessonTab
      : 0,
  );

  const publishLessons = async (data) => {
    setisdisable(true);
    dispatch(lmsAction.publishLesson(data));
  };
  const lessionListData = useSelector((state) => state.getLessonsList);
  const cloneLessonData = useSelector((state) => state.cloneLessonData);
  const Lessondelete = useSelector((state) => state?.deleteLesson);

  const dataHeader = {
    title: "Training Management",

    btnLink: CREATE_LESSON,
    menu: [
      {
        route: LESSON,
        text: "Lessons",
      },
      {
        route: COURSES,
        text: "Courses",
      },
      {
        route: COURSES_SCORM,
        text: "Marketplace",
      },
    ],
  };
  if (checkPrivileges([12, 11])) {
    dataHeader.btnText = "Create Lesson";
  }
  const handleClear = () => {
    dispatch(lmsAction.getAssignedLessonListClear());
    dispatch(lmsAction.getAssignedListClear());
  };
  const defaultData = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    userId: USER_ID(),
    organisationId: ORG_ID(),
    status: defaultLessonTab === 0 ? "" : defaultLessonTab,
    isSendMail: false,
  };

  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10]);
    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    const dataToLoad =
      location?.state?.defaultLessonTab !== undefined &&
      !location?.state?.lessonId
        ? defaultData
        : lessionListData?.filterObj
          ? lessionListData.filterObj
          : defaultData;
    getLessonListData(dataToLoad);
    dispatch(quizAction.createQuizClear());
    dispatch(quizAction.updateQuizClear());
    dispatch(lmsAction.createLessonClear());
    dispatch(lmsAction.updateLessonClear());
    dispatch(lmsAction.clearCategoryList());
    setOpenGrandAccess(false);
    dispatch(lmsAction.clearDeleteLesson(""));
    handleClear();
  }, []);

  useEffect(() => {
    if (location?.state?.defaultLessonTab !== undefined) {
      const { defaultLessonTab: _defaultLessonTab, ...rest } =
        location.state ?? {};
      navigate(location.pathname, {
        replace: true,
        state: Object.keys(rest).length ? rest : null,
      });
    }
  }, [location?.state, location?.pathname, navigate]);

  const getLessonListData = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(lmsAction.getLessonsList(data));
    dispatch(lmsAction.getLessonsListFilterObj(data));
  };
  const getategoryListData = (data) => {
    dispatch(lmsAction.getCategoryList(data));
  };
  const categoryListData = useSelector((state) => state.getCategoryList?.data);
  const showLoader = useSelector(
    (state) =>
      state.getCategoryList?.isLoading ||
      state.cloneLessonData?.isLoading ||
      state.publishLesson?.isLoading ||
      state?.deleteLesson?.isLoading,
  );
  const deleteLesson = (data) => {
    dispatch(lmsAction.deleteLesson(data));
  };

  useEffect(() => {
    if (lessionListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Lessons has been sent to registered email ID");
    }
  }, [lessionListData]);

  useEffect(() => {
    if (
      Lessondelete?.status === API_STATUS?.SUCCESS &&
      Lessondelete?.responseMessages?.responseCode === "HBNG018" &&
      openGrandAccess === false
    ) {
      setOpenGrandAccess(true);
    }
  }, [Lessondelete]);

  const cloneLesson = (data) => {
    setIscloneBtnClick(true);
    dispatch(lmsAction.cloneLesson(data));
  };

  useEffect(() => {
    const allowedRoutes = [LESSON, LESSONDETAIL, USER_ASSIGNED_LESSON];
    const currentPathname = location.pathname;

    if (currentPathname === LESSON) {
      const previousRoute = getPreviousRoute();

      const isFromEditRoute =
        previousRoute && previousRoute.startsWith("/lesson/edit/");

      if (
        previousRoute &&
        !allowedRoutes.includes(previousRoute) &&
        !isFromEditRoute
      ) {
        dispatch(lmsAction.getLessonsListFilterObj(defaultData));
        getLessonListData(defaultData);
      }
    }
  }, [location.pathname, dispatch]);

  return (
    <>
      {showLoader && <Loader />}
      <LmsHeader dataHeader={dataHeader} />
      <ToastContainer />
      <LessonList
        LessondeleteStatus={LessondeleteStatus}
        publishLessonStatus={publishLessonStatus}
        onSubmit={publishLessons}
        getLessonListData={getLessonListData}
        lessionListData={lessionListData}
        categoryListData={categoryListData}
        deleteLesson={deleteLesson}
        setisdisable={setisdisable}
        isdisable={isdisable}
        cloneLesson={cloneLesson}
        cloneLessonData={cloneLessonData}
        toast={toast}
        iscloneBtnClick={iscloneBtnClick}
        setIscloneBtnClick={setIscloneBtnClick}
        getategoryListData={getategoryListData}
        tableClass={"increaseHeight"}
        setOpenGrandAccess={setOpenGrandAccess}
        openGrandAccess={openGrandAccess}
        DeletedCourse={Lessondelete?.result?.coursesNames}
        defaultTabValue={defaultLessonTab}
      />
    </>
  );
};

export default LessonsContainer;
